var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('label',{staticClass:"h6",style:(`color: ${_vm.isMobilePhoneValid ? 'rgba(0, 0, 0, 0.6)' : '#c71900'};`),attrs:{"for":"mobile"}},[_vm._v("Mobile*")]),_c('vue-tel-input',{staticClass:"mt-1",attrs:{"field":_vm.field,"value":_vm.modelValue,"input-options":{
      id: _vm.field.name,
      required: !!_vm.field.required,
      readonly: !!_vm.field.readonly,
      name: `_${ _vm.field.name }`,
      placeholder: _vm.field.label
    },"valid-characters-only":"","mode":"international","default-country":"fr","preferred-countries":['FR']},on:{"input":_vm.handleChanges,"validate":_vm.handleValidation}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }